// extracted by mini-css-extract-plugin
export default {"modalContent":"UnblockClientModal_modalContent__LNwJR","text":"UnblockClientModal_text__n0BU4"};